// extracted by mini-css-extract-plugin
export var highlightFade = "_3q-4";
export var highlighted = "_3q-3";
export var table = "_3q-1";
export var tableContainer = "_3q-0";
export var totalsRow = "_3q-2";